(function () {

  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  }

  function saveWishlist(list) {
    localStorage.setItem("wishlist", JSON.stringify(list));
  }

  function updateHeaderCount() {
    const countEl = document.querySelector(".wishlist-count");
    if (!countEl) return;

    const count = getWishlist().length;

    if (count > 0) {
      countEl.textContent = count;
      countEl.classList.remove("hidden");
    } else {
      countEl.classList.add("hidden");
    }
  }

  function toggleWishlist(btn) {
    const handle = btn.dataset.handle;
    if (!handle) return;

    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
      btn.classList.remove("active");
      btn.querySelector(".wishlist-icon").textContent = "♡";
    } else {
      wishlist.push(handle);
      btn.classList.add("active");
      btn.querySelector(".wishlist-icon").textContent = "♥";
    }

    saveWishlist(wishlist);
    updateHeaderCount();
  }

  function initWishlistButtons() {
    document.querySelectorAll(".wishlist-btn").forEach(btn => {

      // initial state
      if (getWishlist().includes(btn.dataset.handle)) {
        btn.classList.add("active");
        btn.querySelector(".wishlist-icon").textContent = "♥";
      }

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(btn);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initWishlistButtons();
    updateHeaderCount();
  });

})();
